export default {
  home: 'Início',
  menu: 'Menu',
  orders: 'Encomendas',
};
